import {Injectable} from "@angular/core";

@Injectable()
export class OptionsConsultants {
    status = [
        {id:true,itemName:'Ativo'},
        {id:false,itemName:'Inativo'}
    ];

    statusClient = [
        {id:true,itemName:'Cliente Ativo'},
        {id:false,itemName:'Cliente Inativo'}
    ];

    statusSelfFill = [
        {id:true,itemName:'Preenchida'},
        {id:false,itemName:'Não preencheu'}
    ];

    division = [
        {id: 1, itemName: "Omnik"}
    ];

    model = [
        {id:1, itemName: "PJ"},
        {id:2, itemName: "CLT"},
        {id:3, itemName: "Estagiário"},
        {id:4, itemName: "Outros"}
    ];

    honorarium = [
        {id:1, itemName: "Hora Aberta"},
        {id:2, itemName: "Hora Fechada"}
    ];

    additivePending = [
        {id:1,itemName:'Reajuste de Valor pendente'},
        {id:3,itemName:'Alteração de Razão Social pendente'}
    ];
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/consultants/OptionsConsultant.ts